export interface PortfolioRoom {
  id: string;
  name: string;
  images: string[];
  order?: number;
}

export interface PortfolioReview {
  id: string;
  portfolioId: string;
  name: string;
  description: string;
}

export interface PortfolioProject {
  id: string;
  projectName: string;
  projectNameAr: string;
  description: string;
  descriptionAr: string;
  location: string;
  priceMin: number;
  priceMax: number;
  homeType: string;
  packageId: string;
  numberOfBedrooms: number;
  timeline: number;
  year: number;
  overviewImage: string;
  rooms: PortfolioRoom[];
  review?: PortfolioReview;
  isPublished?: boolean;
  modelId?: string;
  otherModel?: string;
  order?: number;
}

export const DEFAULT_ROOMS = [
  'Overview',
  'Living Room',
  'Dining Room',
  'Bedroom',
  'Double Bedroom',
  'Outdoor Lounge'
];

export const emptyPortfolioForm: Omit<PortfolioProject, 'id'> = {
  projectName: '',
  projectNameAr: '',
  description: '',
  descriptionAr: '',
  location: '',
  priceMin: 0,
  priceMax: 0,
  homeType: '',
  packageId: '',
  numberOfBedrooms: 1,
  timeline: 1,
  year: new Date().getFullYear(),
  overviewImage: '',
  rooms: [],
  review: undefined,
  isPublished: false,
  modelId: '',
  otherModel: '',
  order: 0
};
